"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireDefault(require("../../common/Tooltip/Tooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FuturesInstrumentTableItem = function FuturesInstrumentTableItem(props) {
  var value = props.value,
    valueCurrency = props.valueCurrency,
    valueTooltip = props.valueTooltip,
    label = props.label,
    secondLabel = props.secondLabel,
    secondLabelTooltip = props.secondLabelTooltip,
    labelTooltip = props.labelTooltip,
    labelDivider = props.labelDivider,
    classModifiers = props.classModifiers,
    baseClasses = props.baseClasses;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('row', classModifiers)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('value-row')
  }, valueTooltip ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    text: valueTooltip
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('value', 'with-tooltip')
  }, value)) : /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('value')
  }, value), valueCurrency && /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('value-currency')
  }, "\xA0", valueCurrency)), /*#__PURE__*/_react["default"].createElement("div", null, labelTooltip ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    text: labelTooltip
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('title', 'with-tooltip')
  }, label)) : /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('title')
  }, label), labelDivider && /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('title', 'divider')
  }, labelDivider), secondLabel && (secondLabelTooltip ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    text: secondLabelTooltip
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('second-title', 'with-tooltip')
  }, secondLabel)) : /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('second-title')
  }, secondLabel))));
};
FuturesInstrumentTableItem.propTypes = {
  value: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  baseClasses: _propTypes["default"].func.isRequired,
  classModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
FuturesInstrumentTableItem.defaultProps = {
  classModifiers: []
};
var _default = exports["default"] = FuturesInstrumentTableItem;